import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { fetchData } from 'reducers/dataTable';
import withDataTableController from 'components/DataTable/DataTableController/DataTableController';
// components
import { FormattedMessage } from 'react-intl';
import DateRangePicker from 'components/DatePicker/DateRangePicker';
import ReactSelect from 'components/Select/ReactSelect';
import BarnsheetsGroupSurveysTable from './BarnsheetsGroupSurveysTable';
// utils
import cn from 'classnames';
import moment from 'moment';
import { getDatesFromRange } from 'utils/treatmentChartsHelper.js';
// constants
import { antibioticStatsOptions } from 'constants.js';
// styles
import './BarnsheetsGroupSurveys.scss';

class BarnsheetsGroupSurveys extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      period_name: 'year_to_date',
      ...getDatesFromRange('year_to_date'),
    };
  }

  componentDidMount = () => {
    const { fetchData, reqParams } = this.props;
    const { startDate, endDate } = this.state;

    const params = {
      ...reqParams,
      date_start: startDate ? startDate.format('YYYY-MM-DD') : null,
      date_end: endDate ? endDate.format('YYYY-MM-DD') : null,
    };

    fetchData(params);
  };

  onDateChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate }, () => {
      if (startDate && endDate) {
        const { fetchData, reqParams } = this.props;
        const params = {
          ...reqParams,
          date_start: startDate.format('YYYY-MM-DD'),
          date_end: endDate.format('YYYY-MM-DD'),
        };
        fetchData(params);
      }
    });
  }

  onPeriodSelect = (option) => {
    if (!option) return;
    const { value } = option;
    if (value !== this.state.period_name) {
      const dates = getDatesFromRange(value);
      this.setState({ period_name: value, ...dates }, () => {
        const { startDate, endDate } = this.state;
        if (startDate && endDate) {
          const { fetchData, reqParams } = this.props;
          const params = {
            ...reqParams,
            date_start: startDate.format('YYYY-MM-DD'),
            date_end: endDate.format('YYYY-MM-DD'),
          };
          fetchData(params);
        }
      });
    }
  };

  render() {
    const { isLoading, resources, reqParams: { page, per_page, sort }, meta: { total },
      onSearchChange, onSortChange, onPageChange, onPerPageChange } = this.props;
    const { startDate, endDate, period_name } = this.state;

    const paginationProps = {
      totalItems: total,
      currentPage: page,
      perPage: per_page,
      onPageChange,
      onPerPageChange,
    };

    return (
      <div className={cn('BarnsheetsSurvays')}>
        <div className={cn('mb-20 filters-wrap')}>
          {period_name === 'custom' && (
            <DateRangePicker
              className={cn('date-picker')}
              startDate={startDate}
              endDate={endDate}
              isOutsideRange={(day) => (day.isAfter(moment(), 'day'))}
              onDatesChange={this.onDateChange}
            />
          )}
          <ReactSelect
            className={cn('select-period')}
            placeholder={<FormattedMessage id="general.selectPeriod" />}
            options={antibioticStatsOptions}
            valueKey="value"
            labelKey="name"
            value={period_name}
            onChange={this.onPeriodSelect}
            noInputMargin
            searchable={false}
          />
        </div>
        <BarnsheetsGroupSurveysTable
          data={resources}
          sort={sort}
          onSortChange={onSortChange}
          paginationProps={paginationProps}
          isLoading={isLoading}
          reqParams={this.props.reqParams}
          onSearchChange={onSearchChange}
        />
      </div>
    );
  }
}

BarnsheetsGroupSurveys.contextTypes = {
  router: T.object.isRequired,
};

BarnsheetsGroupSurveys.propTypes = {
  fetchData: T.func.isRequired,
  isLoading: T.bool.isRequired,
  resources: T.array.isRequired,
  reqParams: T.object.isRequired,
  meta: T.object.isRequired,
  onSearchChange: T.func.isRequired,
  onSortChange: T.func.isRequired,
  onPageChange: T.func.isRequired,
  onPerPageChange: T.func.isRequired,
};

export default connect(
  (state) => ({
    currentUser: state.auth.user,
    resources: state.dataTable.barnsheetsGroupSurveys.resources,
    isLoading: state.dataTable.barnsheetsGroupSurveys.isLoading,
    pigGroup: state.barnsheets.groupCheckups.pigGroup,
    reqParams: state.dataTable.barnsheetsGroupSurveys.params,
    meta: state.dataTable.barnsheetsGroupSurveys.meta,
  }), (dispatch, { params }) => (
    {
      fetchData: (query) => dispatch(fetchData(`/pig_groups/${params.id}/daily_checkup_surveys`,
        'barnsheetsGroupSurveys', query)),
    }
  )
)(withDataTableController('fetchData', 'reqParams')(BarnsheetsGroupSurveys));
